import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "posArrow-up",
  "use": "posArrow-up-usage",
  "viewBox": "0 0 43.55 43.37",
  "content": "<symbol viewBox=\"0 0 43.55 43.37\" id=\"posArrow-up\"><g id=\"posArrow-up_图层_2\" data-name=\"图层 2\"><g id=\"posArrow-up_图层_1-2\" data-name=\"图层 1\"><path d=\"M19.22,1.66.4,38.4c-1.13,2.21.28,5,2.55,5l18.83-5.49L40.6,43.38c2.27,0,3.69-2.77,2.55-5L24.33,1.66A2.79,2.79,0,0,0,19.22,1.66Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/posArrow-up.svg
// module id = gyH+
// module chunks = 264